import { render, staticRenderFns } from "./ShopShopAddress.vue?vue&type=template&id=bb394f6c&scoped=true"
import script from "./ShopShopAddress.vue?vue&type=script&lang=js"
export * from "./ShopShopAddress.vue?vue&type=script&lang=js"
import style0 from "./ShopShopAddress.vue?vue&type=style&index=0&id=bb394f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb394f6c",
  null
  
)

export default component.exports